<template>
  <div class="tw-container tw-mx-auto tw-pt-8">
    <V2ForeignersBasicInfoView
      v-if="!isEditing"
      @open-edit="isEditing = true"
    />
    <V2ForeignersBasicInfoEdit
      v-else
      @close-edit="isEditing = false"
    />
  </div>
</template>

<script>
import V2ForeignersBasicInfoView from './ForeignersBasicInfoView.vue';
import V2ForeignersBasicInfoEdit from './ForeignersBasicInfoEdit.vue';

export default {
  components: {
    V2ForeignersBasicInfoView,
    V2ForeignersBasicInfoEdit,
  },
  data() {
    return {
      isEditing: false,
    };
  },
};
</script>
